// extracted by mini-css-extract-plugin
export default {"tag":"lsf-tag","tag_size_small":"lsf-tag_size_small","tag_size_compact":"lsf-tag_size_compact","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630380661
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  